import { compose } from 'redux';
import { connect } from 'react-redux';
import withFormValidation from 'app/HOC/withFormValidation';
import paymentModule from 'app/store/payment';
import giftcardsModule from 'app/store/giftcards';
import sessionsModule from 'app/store/sessions';
import user from 'app/store/user';
import StepTickets from './StepCheckout.component';
import schema from './StepCheckout.schema';
import bookingsModule from 'app/store/bookings';

const {
  reserveRequest,
  buyRequest,
  buyWithBonusRequest,
  applyGiftcardRequest,
  buyWithGiftRequest,
  stepCheckoutRequest,
} = paymentModule.actions;

const { bookingRequest } = bookingsModule.actions;
const { giftcardsRequest, addGiftcardRequest, addLogoutGiftcardSend, clearGiftcardSessionSend, dataSetAgainGiftcard, restrictionsRequest } = giftcardsModule.actions;
const { wizardSet } = sessionsModule.actions;
const { reservedPaymentRequest, reservedGiftcardPaymentRequest } = user.actions;

const mapStateToProps = (
  {
    user,
    order,
    bookings: { booking },
    sessions: {
      session: { session, restrictions },
      wizard
    },
    information: { legalInfoContent },
    giftcards,
    layout: { isLoading },
    payment
  }) => (
  {
    isLoggedIn: !!user.user,
    isReserved: !!booking,
    userSessionId: order ? order?.userSessionId : null,
    isReservationEnded: session.status === 'yellow',
    order,
    legalInfo: legalInfoContent.filter(info => info.type !== 'termsOfUseBonuscard'),
    userGiftcards: giftcards.giftcards,
    newGiftcardAdd: giftcards.newGiftcardAdd,
    newGiftcard: giftcards.newGiftcard,
    // newGiftcardWithoutLogin: giftcards.newGiftcardWithoutLogin,
    child: wizard.child,
    adult: wizard.adult,
    reduced: wizard.reduced,
    packageRegular: wizard.packageRegular,
    packageChild: wizard.packageChild,
    packageReduced: wizard.packageReduced,
    packageClub: wizard.packageClub,
    isBonus: wizard.isBonus,
    isGiftCardApplied: wizard.isGiftCardApplied,
    userRestrictions: giftcards.restrictions,
    loader: isLoading,
    reservedBooking: user?.reservedBooking,
    giftCardpayment: payment?.giftCardpayment,
    reservedGiftResult: user?.reservedGiftResult,
    paymentGiftcardData: payment?.paymentGiftcardData ? payment?.paymentGiftcardData : {},
    bonusCardSimplePayment: payment?.bonusCardSimplePayment
  });

const mapDispatchToProps = {
  reserve: reserveRequest,
  buy: buyRequest,
  getGiftcards: giftcardsRequest,
  // addGiftcard: addTicketGiftcardRequest,
  addGiftcard: addGiftcardRequest,
  buywithBonus: buyWithBonusRequest,
  applyGiftcard: applyGiftcardRequest,
  buyWithGift: buyWithGiftRequest,
  saveWizard: wizardSet,
  reservedPayment: reservedPaymentRequest,
  reservedGiftcardPayment: reservedGiftcardPaymentRequest,
  fetchBooking: bookingRequest,
  addLogoutGiftcard: addLogoutGiftcardSend,
  clearGiftcardSession: clearGiftcardSessionSend,
  dataSetAgain: dataSetAgainGiftcard,
  getRestrictions: restrictionsRequest,
  description: stepCheckoutRequest
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFormValidation(schema)
)(StepTickets);
